export default __webpack_public_path__ + "static/media/paper_blue.4801484b.svg";